import React from 'react';

export default (value) => {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  });
  
  return ref.current;
};
